import React, { useEffect, useState } from 'react';
import Container from '@mui/material/Container';
import { useDispatch, useSelector } from 'react-redux'

import {
  Box, Card, Grid, Typography, Avatar, CardHeader, CardContent, Button, useTheme, Pagination, Fab, Drawer
} from '@mui/material'
import { NavLink } from 'react-router-dom'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CakeIcon from '@mui/icons-material/Cake';
import PersonIcon from '@mui/icons-material/Person';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import WorkIcon from '@mui/icons-material/Work';
import style from './ServiceGroom.module.css'
import LanguageIcon from '@mui/icons-material/Language';
import FilterListIcon from '@mui/icons-material/FilterList';
import maleImg from '../../assets/male_modern.png';
import { fetchUserDetails } from '../../features/auth/authAction';
import {
  getUserDesignation, getUserDistrict, getUserCountry,
  getUserCaste, getUserMarriageState, getReligion
} from '../../features/filterSectionAction';
import moment from 'moment'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Slider from '@mui/material/Slider';

import slide2 from '../../images/bg-informationPage.jpeg';
import slide3 from '../../images/slide1.webp';
import slide4 from '../../images/slide2.jpg';
import slide5 from '../../images/slide3.jpg';

const images = [slide2, slide3, slide4, slide5];

const labels = {
  si: {
    filterHeader: 'සොයන්නේ',
    designation: 'තනතුරු',
    marriageState: 'විවාහක තත්වය',
    age: 'වයස',
    religion: 'ආගම',
    city: 'නගරය',
    district: 'දිස්ත්රික්ක',
    reset: 'යළි පිහිටුවන්න',
    none: 'කිසිවක් නැත',
    single: 'අවිවාහක',
    married: 'විවාහක',
    divorced: 'දික්කසාද වූ',
    widowed: 'වැන්දඹු/නඳිවු',
    buddhism: 'බුද්ධාගම',
    hinduism: 'හින්දු ආගම',
    islam: 'ඉස්ලාම් ආගම',
    christianity: 'ක්‍රිස්තියානි ආගම',
    catholic: 'කතෝලික ආගම',
    other: 'වෙනත්',
  },
  en: {
    filterHeader: 'Search',
    designation: 'Profession',
    marriageState: 'Marital Status',
    age: 'Age',
    religion: 'Religion',
    city: 'City',
    district: 'District',
    reset: 'Reset',
    none: 'None',
    single: 'Single',
    married: 'Married',
    divorced: 'Divorced',
    widowed: 'Widowed',
    buddhism: 'Buddhism',
    hinduism: 'Hinduism',
    islam: 'Islam',
    christianity: 'Christianity',
    catholic: 'Catholic',
    other: 'Other',
  }
};

const ServiceGroom = ({ language }) => {
  const theme = useTheme();

  const t = labels[language] ?? labels.si;

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const initialState = {
    designation: '',
    religion: '',
    caste: '',
    city: '',
    district: '',
    marriageState: ''
  }
  const userDetails = useSelector(state => state.user?.usersInfo?.userData);
  const loggedUserInfo = useSelector((state) => state.auth?.profileInfo?.user)
  const designationList = useSelector((state) => state.userDesignation?.designationData?.designation)
  const regionList = useSelector((state) => state.userDesignation?.religionListData?.religionList)
  const countryList = useSelector((state) => state.userDesignation?.countryListData?.countryList)
  const districtList = useSelector((state) => state.userDesignation?.districtListData?.districtList)
  const casteList = useSelector((state) => state.userDesignation?.casteListData?.casteList)
  const marriageList = useSelector((state) => state.userDesignation?.marriageListData?.marriageList)
  const paidList = useSelector((state) => state.cartDetails?.paidUserList);

  const [filterValue, setFilterValue] = useState(initialState);
  const [ageValue, setAgeValue] = React.useState([18, 60]);
  const minDistance = 10;

  // Pagination state
  const [page, setPage] = useState(1);
  const cardsPerPage = 6;

  // Mobile filter drawer state
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

  const derivedCityList = [...new Set(userDetails?.map(user => user.city).filter(Boolean))].sort();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUserDetails())
    dispatch(getUserDesignation())
    dispatch(getReligion())
    dispatch(getUserMarriageState())
    dispatch(getUserCaste())
    dispatch(getUserCountry())
    dispatch(getUserDistrict())
  }, [dispatch])
  const calculateAge = (birthdayString) => {
    const birthDate = new Date(birthdayString);
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    if (
      currentDate.getMonth() < birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() &&
        currentDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleAge = (event, newValue, activeThumb) => {
    console.log(newValue, activeThumb)
    if (activeThumb === 0) {
      setAgeValue([Math.min(newValue[0], ageValue[1] - minDistance), ageValue[1]]);
    } else {
      setAgeValue([ageValue[0], Math.max(newValue[1], ageValue[0] + minDistance)]);
    }

  };
  function valuetext(value) {
    return `${value}°C`;
  }
  const handleFilter = (e) => {
    const value = e.target.value
    setFilterValue({
      ...filterValue,
      [e.target.name]: value
    })
  }

  const genderFiltered = userDetails?.filter((value) => value.gender.toLowerCase() === 'male')
  const filter = (value) => {
    const {
      designation,
      religion,
      caste,
      city,
      district,
      marriageState
    } = filterValue;
    let isMatching = true;

    if (designation && value.profession?.toLowerCase() !== designation.toLowerCase()) isMatching = false;
    if (religion && value.religion?.toLowerCase() !== religion.toLowerCase()) isMatching = false;
    if (caste && value.caste?.toLowerCase() !== caste.toLowerCase()) isMatching = false;
    if (city && value.city?.toLowerCase() !== city.toLowerCase()) isMatching = false;
    if (district && value.district?.toLowerCase() !== district.toLowerCase()) isMatching = false;
    if (marriageState && value.civilState?.toLowerCase() !== marriageState.toLowerCase()) isMatching = false;
    if (value.age < ageValue[0] || value.age > ageValue[1]) isMatching = false;
    return isMatching;
  };
  const finalData = genderFiltered?.filter(value => filter(value));

  // Pagination logic
  const totalPages = Math.ceil((finalData?.length || 0) / cardsPerPage);
  const startIndex = (page - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const paginatedData = finalData?.slice(startIndex, endIndex);

  const handlePageChange = (event, value) => {
    setPage(value);
    // Scroll to top of cards section smoothly
    window.scrollTo({ top: 300, behavior: 'smooth' });
  };

  // Reset to page 1 when filters change
  useEffect(() => {
    setPage(1);
  }, [filterValue, ageValue]);
  return (
    <>
      <Box sx={{
        background: theme.palette.mode === 'light'
          ? 'linear-gradient(135deg, rgba(5, 74, 73, 0.05) 0%, rgba(212, 175, 55, 0.05) 100%)'
          : 'rgba(255,255,255,0.05)',
        py: { xs: 3, md: 4 },
        mb: 3,
        borderBottom: '3px solid',
        borderImage: `${theme.palette.custom.secondaryGradient} 1`,
      }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            className={style.services}
            sx={{
              textAlign: 'center',
              mb: 0,
              fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
              color: 'primary.main'
            }}
          >
            GROOMS/මනාලයෝ
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mt: 1,
              color: 'text.secondary',
              fontSize: { xs: '0.9rem', sm: '1rem' },
            }}
          >
            Find your perfect match
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Filter sidebar - hidden on mobile, visible on md+ */}
          <Grid item xs={12} sm={12} md={4} lg={3} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Container>
              <Box className={style.filterSection} sx={{ position: { md: 'sticky' }, top: { md: 96 } }}>
                <Typography variant="h6" className={style.filterHeader} sx={{ mb: 2 }}>
                  {t.filterHeader}
                </Typography>
                <FormControl sx={{ m: { xs: 1, sm: 2 }, minWidth: { xs: '100%', sm: 220 }, width: { xs: '100%', sm: 'auto' } }} size="small">
                  <InputLabel id="demo-select-small-label">{t.designation}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    name="designation"
                    value={filterValue.designation}
                    label={t.designation}
                    onChange={handleFilter}
                  >

                    {designationList?.map((values, index) => {
                      return <MenuItem key={index} value={values.profession}>{values.profession}</MenuItem>
                    })}
                    <MenuItem value="">
                      <em>{t.none}</em>
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 2, minWidth: 220 }} size="small">
                  <InputLabel id="demo-select-small-label">{t.marriageState}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={filterValue.marriageState}
                    name='marriageState'
                    label={t.marriageState}
                    onChange={handleFilter}
                  >
                    <MenuItem value="single">{t.single}</MenuItem>
                    <MenuItem value="married">{t.married}</MenuItem>
                    <MenuItem value="divorced">{t.divorced}</MenuItem>
                    <MenuItem value="widowed">{t.widowed}</MenuItem>
                    <MenuItem value="">
                      <em>{t.none}</em>
                    </MenuItem>
                    {/* {marriageList?.map((values, index) => {
                    return <MenuItem key={index} value={values.civilState}>{values.civilState}</MenuItem>
                  })} */}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 2, minWidth: 220 }} size="small">
                  <InputLabel id="age-select-label">{t.age}</InputLabel>
                  <Slider
                    getAriaLabel={() => 'Minimum distance'}
                    value={ageValue}
                    onChange={handleAge}
                    valueLabelDisplay="auto"
                    getAriaValueText={valuetext}
                    disableSwap
                    color="primary"
                    sx={{ mt: 3 }}
                  />
                </FormControl>
                <FormControl sx={{ m: 2, minWidth: 220 }} size="small">
                  <InputLabel id="demo-select-small-label">{t.religion}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={filterValue.religion}
                    name="religion"
                    label={t.religion}
                    onChange={handleFilter}
                  >
                    <MenuItem value="buddhism">{t.buddhism}</MenuItem>
                    <MenuItem value="hinduism">{t.hinduism}</MenuItem>
                    <MenuItem value="islam">{t.islam}</MenuItem>
                    <MenuItem value="christianity">{t.christianity}</MenuItem>
                    <MenuItem value="catholic">{t.catholic}</MenuItem>
                    <MenuItem value="other">{t.other}</MenuItem>
                    <MenuItem value="">
                      <em>{t.none}</em>
                    </MenuItem>
                    {/* {regionList?.map((values, index) => {
                    return <MenuItem key={index} value={values.religion}>{values.religion}</MenuItem>
                  })} */}
                  </Select>
                </FormControl>
                {/* <FormControl sx={{ m: 2, minWidth: 220 }} size="small">
                <InputLabel id="demo-select-small-label">කුලය</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={filterValue.caste}
                  name="caste"
                  label="කුලය"
                  onChange={handleFilter}
                >
                  <MenuItem value="">
                    <em>කිසිවක් නැත</em>
                  </MenuItem>
                  {casteList?.map((values, index) => {
                    return <MenuItem key={index} value={values.caste}>{values.caste}</MenuItem>
                  })}
                </Select>
              </FormControl> */}
                <FormControl sx={{ m: 2, minWidth: 220 }} size="small">
                  <InputLabel id="demo-select-small-label">{t.city}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={filterValue.city}
                    name="city"
                    label={t.city}
                    onChange={handleFilter}
                  >
                    <MenuItem value="">
                      <em>{t.none}</em>
                    </MenuItem>
                    {derivedCityList?.map((city, index) => {
                      return <MenuItem key={index} value={city}>{city}</MenuItem>
                    })}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 2, minWidth: 220 }} size="small">
                  <InputLabel id="demo-select-small-label">{t.district}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    name="district"
                    value={filterValue.district}
                    label={t.district}
                    onChange={handleFilter}
                  >
                    <MenuItem value="colombo">කොළඹ</MenuItem>
                    <MenuItem value="gampaha">ගම්පහ</MenuItem>
                    <MenuItem value="kalutara">කළුතර</MenuItem>
                    <MenuItem value="kandy">මහනුවර</MenuItem>
                    <MenuItem value="matale">මැටලේ</MenuItem>
                    <MenuItem value="nuwara-eliya">නුවරඑළිය</MenuItem>
                    <MenuItem value="galle">ගාල්ල</MenuItem>
                    <MenuItem value="matara">මාතර</MenuItem>
                    <MenuItem value="hambantota">හම්බන්තොට</MenuItem>
                    <MenuItem value="jaffna">යාපනය</MenuItem>
                    <MenuItem value="kilinochchi">කිලිනොච්චි</MenuItem>
                    <MenuItem value="mannar">මන්නාරම</MenuItem>
                    <MenuItem value="vavuniya">වවුනියාව</MenuItem>
                    <MenuItem value="mullaitivu">මුලතිව්</MenuItem>
                    <MenuItem value="batticaloa">මඩකලපුව</MenuItem>
                    <MenuItem value="ampara">අම්පාර</MenuItem>
                    <MenuItem value="trincomalee">ත්‍රිකුණාමලය</MenuItem>
                    <MenuItem value="kurunegala">කුරුණෑගල</MenuItem>
                    <MenuItem value="puttalam">පුත්තලම</MenuItem>
                    <MenuItem value="anuradhapura">අනුරාධපුර</MenuItem>
                    <MenuItem value="polonnaruwa">පොළොන්නරුව</MenuItem>
                    <MenuItem value="badulla">බදුල්ල</MenuItem>
                    <MenuItem value="monaragala">මොනරාගල</MenuItem>
                    <MenuItem value="ratnapura">රත්නපුර</MenuItem>
                    <MenuItem value="kegalle">කෑගල්ල</MenuItem>
                    <MenuItem value=""> <em>කිසිවක් නැත</em></MenuItem>
                    {/* {districtList?.map((values, index) => {
                    return <MenuItem key={index} value={values.district}>{values.district}</MenuItem>
                  })} */}
                  </Select>
                </FormControl>
                <Box className={style.resetButton}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setFilterValue(initialState)}
                    sx={{
                      borderRadius: 999,
                      '&:hover': {
                        color: '#fff',
                        backgroundColor: 'primary.main',
                        borderColor: 'primary.main'
                      }
                    }}
                  >
                    {t.reset}</Button>
                </Box>
              </Box>
            </Container>
            <Container>
              <Box
                className={style.filterSection}
                sx={{
                  width: '100%',
                  height: '480px',
                  backgroundImage: `url(${images[currentIndex]})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  transition: 'background-image 1s ease-in-out',
                  borderRadius: '16px',
                  mt: '1rem',
                  boxShadow: 'inset 0 0 0 1000px rgba(0,0,0,0.25)'
                }}
              />
            </Container>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <Container>
              <Container sx={{
                borderRadius: '0.2rem', display: 'flex', flexDirection: 'column',
              }}>
                {userDetails?.length > 0 ? (
                  <>
                    <Grid container spacing={3} justifyContent="center">
                      {paginatedData?.map((value, index) => (
                        <Grid item key={index} xs={12} sm={12} lg={6}>
                          <Card
                            className={style.groomCard}
                            sx={{
                              borderRadius: 4,
                              mb: 2,
                              position: 'relative',
                              overflow: 'hidden',
                              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                              bgcolor: 'background.paper',
                              border: theme.palette.custom.sectionBorder,
                              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                              '&:hover': {
                                transform: 'translateY(-8px) scale(1.02)',
                                boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                                borderColor: 'primary.main',
                              },
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: theme.palette.custom.secondaryGradient,
                                opacity: 0,
                                transition: 'opacity 0.3s ease',
                                zIndex: 1,
                              },
                              '&:hover::before': {
                                opacity: 1,
                              },
                            }}
                          >
                            <CardContent sx={{ position: 'relative', zIndex: 1 }}>
                              <Box sx={{
                                flexGrow: 1,
                                // maxHeight: '15rem', // REMOVED constraint to fix cutoff layout

                              }}>
                                <Grid key={index} container spacing={2} xs={12} columns={12}>
                                  <CardHeader
                                    avatar={
                                      <Avatar
                                        sx={{ backgroundColor: 'red' }}
                                        src={maleImg}
                                        alt="Male Avatar"
                                      />
                                    }
                                    title={
                                      <Typography variant="h5" sx={{ fontSize: '20px' }}>
                                        {value.firstName}
                                        {/* {value.lastName} */}
                                      </Typography>
                                    }
                                    subheader={moment(value.createdAt).format('YYYY/MM/DD')}
                                  />
                                  <Grid item xs={12} sm={4}>
                                    <Typography variant="body1" component="div" className={style.icon}>
                                      <LocationOnIcon sm={{ mr: 1 }} />
                                      <span >{value.city}</span>
                                    </Typography>
                                  </Grid>
                                  <Grid container item xs={12} columns={12}>
                                    <Grid sm={4} xs={12}>
                                      <Typography variant="body1" component="div" className={style.icon}>
                                        <CakeIcon sx={{ mr: 1 }} />
                                        {value.age}
                                      </Typography>
                                    </Grid>
                                    <Grid sm={4} xs={12}>
                                      <Typography variant="body1" component="div" className={style.icon}>
                                        <PersonIcon sx={{ mr: 1 }} />
                                        {value.ethnics}
                                      </Typography>
                                    </Grid>
                                    <Grid sm={4}>
                                      <Typography variant="body1" component="div" className={style.icon}>
                                        <LocalLibraryIcon sx={{ mr: 1 }} />
                                        {value.religion}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid container item xs={12} columns={12}>
                                    <Grid sm={4}>
                                      <Typography variant="body1" component="div" className={style.icon}>
                                        <WorkIcon sx={{ mr: 1 }} />
                                        {value.profession}
                                      </Typography>
                                    </Grid>
                                    <Grid sm={4}>
                                      <Typography variant="body1" component="div" className={style.icon}>
                                        <SquareFootIcon sx={{ mr: 1 }} />
                                        {value.height}
                                      </Typography>
                                    </Grid>
                                    <Grid sm={4}>
                                      <Typography variant="body1" component="div" className={style.icon}>
                                        <LanguageIcon sx={{ mr: 1 }} />
                                        {value.city}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    lg={12}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'baseline',
                                      justifyContent: 'flex-end',
                                      mt: 1,
                                    }}
                                  >
                                    {loggedUserInfo ? (
                                      <NavLink
                                        to={`/moreDetailsPage/${loggedUserInfo?.id}/${value?.userId}`}
                                        style={{ textDecoration: 'none' }}
                                      >
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          sx={{
                                            borderRadius: 999,
                                            '&:hover': {
                                              color: '#fff',
                                              backgroundColor: 'primary.main',
                                              borderColor: 'primary.main'
                                            }
                                          }}
                                        >
                                          වැඩිපුර විස්තර
                                        </Button>
                                      </NavLink>
                                    ) : (
                                      <NavLink to={`/login`} style={{ textDecoration: 'none' }}>
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          sx={{
                                            borderRadius: 999,
                                            '&:hover': {
                                              color: '#fff',
                                              backgroundColor: 'primary.main',
                                              borderColor: 'primary.main'
                                            }
                                          }}
                                        >
                                          වැඩිපුර විස්තර
                                        </Button>
                                      </NavLink>
                                    )}
                                  </Grid>
                                </Grid>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>

                    {/* Pagination Component */}
                    {totalPages > 1 && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          mt: 4,
                          mb: 2,
                        }}
                      >
                        <Pagination
                          count={totalPages}
                          page={page}
                          onChange={handlePageChange}
                          color="primary"
                          size="large"
                          sx={{
                            '& .MuiPaginationItem-root': {
                              fontSize: '1rem',
                              fontWeight: 500,
                              borderRadius: '50%',
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                transform: 'scale(1.1)',
                                backgroundColor: 'rgba(5, 74, 73, 0.1)',
                              },
                            },
                            '& .MuiPaginationItem-root.Mui-selected': {
                              background: theme.palette.custom.mainGradient,
                              color: 'white',
                              fontWeight: 700,
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              '&:hover': {
                                background: theme.palette.custom.mainGradient,
                                opacity: 0.9,
                              },
                            },
                          }}
                        />
                      </Box>
                    )}
                  </>
                ) : (
                  "මනාලයන් හමු නොවීය"
                )}
              </Container>
            </Container>
          </Grid>
        </Grid>
      </Container>

      {/* Mobile Floating Filter Button */}
      <Fab
        color="primary"
        aria-label="filters"
        onClick={() => setFilterDrawerOpen(true)}
        sx={{
          display: { xs: 'flex', md: 'none' },
          position: 'fixed',
          bottom: 156, // Positioned above chat button
          left: 24,
          zIndex: 999,
          background: theme.palette.custom.mainGradient,
          boxShadow: '0 4px 16px rgba(5, 74, 73, 0.4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #043d3c 0%, #054A49 100%)',
          }
        }}
      >
        <FilterListIcon />
      </Fab>

      {/* Mobile Filter Drawer */}
      <Drawer
        anchor="bottom"
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            maxHeight: '80vh',
            p: 3,
          }
        }}
      >
        <Box sx={{ position: 'relative' }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, textAlign: 'center', color: 'primary.main' }}>
            {t.filterHeader}
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>{t.designation}</InputLabel>
                <Select
                  name="designation"
                  value={filterValue.designation}
                  label={t.designation}
                  onChange={handleFilter}
                >
                  {designationList?.map((values, index) => (
                    <MenuItem key={index} value={values.profession}>{values.profession}</MenuItem>
                  ))}
                  <MenuItem value=""><em>{t.none}</em></MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>{t.marriageState}</InputLabel>
                <Select
                  value={filterValue.marriageState}
                  name='marriageState'
                  label={t.marriageState}
                  onChange={handleFilter}
                >
                  <MenuItem value="single">{t.single}</MenuItem>
                  <MenuItem value="married">{t.married}</MenuItem>
                  <MenuItem value="divorced">{t.divorced}</MenuItem>
                  <MenuItem value="widowed">{t.widowed}</MenuItem>
                  <MenuItem value=""><em>{t.none}</em></MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>{t.religion}</InputLabel>
                <Select
                  value={filterValue.religion}
                  name="religion"
                  label={t.religion}
                  onChange={handleFilter}
                >
                  <MenuItem value="buddhism">{t.buddhism}</MenuItem>
                  <MenuItem value="hinduism">{t.hinduism}</MenuItem>
                  <MenuItem value="islam">{t.islam}</MenuItem>
                  <MenuItem value="christianity">{t.christianity}</MenuItem>
                  <MenuItem value="catholic">{t.catholic}</MenuItem>
                  <MenuItem value="other">{t.other}</MenuItem>
                  <MenuItem value=""><em>{t.none}</em></MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>{t.city}</InputLabel>
                <Select
                  value={filterValue.city}
                  name="city"
                  label={t.city}
                  onChange={handleFilter}
                >
                  <MenuItem value=""><em>{t.none}</em></MenuItem>
                  {derivedCityList?.map((city, index) => (
                    <MenuItem key={index} value={city}>{city}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 1 }}>{t.age}: {ageValue[0]} - {ageValue[1]}</Typography>
              <Slider
                value={ageValue}
                onChange={handleAge}
                valueLabelDisplay="auto"
                getAriaValueText={valuetext}
                disableSwap
                color="primary"
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => {
                setFilterValue(initialState);
              }}
              sx={{ borderRadius: 2 }}
            >
              {t.reset}
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setFilterDrawerOpen(false)}
              sx={{
                borderRadius: 2,
                background: theme.palette.custom.mainGradient,
              }}
            >
              {t.filterHeader}
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
export default ServiceGroom;